<template>
    <div class="warpper">
        <div class="flex flex-direction align-center">
            <div class="certificate-bg">
                <el-image class="image" :src="file_img" :preview-src-list="[file_img]">
                    <div slot="error">
                        <el-empty description="暂无证书"></el-empty>
                    </div>
                </el-image>
            </div>
            <el-button class="down margin-top" @click="downloadFile(file_img,'会员证书')">下载证书</el-button>
        </div>
    </div>
</template>

<script>
import {getZhengShu} from '@/api/member'
import {IMAGE_PATH} from "@/config/index";
import {downloadFile} from "@/api/login";
export default {
    name: "vipCertificate",
    components: {},
    data() {
        return {
            file_img:''
        }
    },
    created() {
        this.$emit('setIndex', 1, '会员证书')
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async init() {
            let _data = await getZhengShu()
            if (_data.status === 200) {
                this.file_img = IMAGE_PATH + _data.data + '?v='+new Date().getTime()
            }
        },
        async downloadFile(fileUrl,fileName) {
            if (!fileUrl) {
                return;
            }
            let _data = await  downloadFile(fileUrl)
            console.log(fileName)

            let url = window.URL.createObjectURL(new Blob([_data.data]));
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', `${fileName}.png`);
            document.body.appendChild(link);
            link.click();
        }
    }

}
</script>

<style scoped lang="scss">
.warpper {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 67px 30px;
    .certificate-bg {
        width: 828px;
        min-height: 583px;
        padding: 45px;
        margin: 30px auto;
        background: url(../../../../assets/img/certificate-bg.png) no-repeat center;
        background-size: 100% 100%;

        .image {
            display: block;
            width: 728px;
            margin: 0 auto;
        }
    }
    .down {
        width: 200px;
        height: 40px;
        line-height: 40px;
        border-radius: 40px;
        font-size: 16px;
        background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
        linear-gradient(#ff9600, #ff9600);
        background-blend-mode: normal, normal;
        color: #ffffff;
        margin-top: 20px;
        padding: 0;
        &.white {
            background: #ffffff none;
            color: #ff9600;
        }
        &:disabled {
            background: #b4c7e5 none;
        }
    }
}
</style>